module.exports = __webpack_public_path__ + "static/media/sun.f3e7a443.svg";